module.exports = __webpack_public_path__ + "static/media/adonisjs.63f5379b.png";